import { Button, Typography } from "antd";
import { FileText } from "lucide-react";
import React from "react";

const { Title, Text } = Typography;

interface DocumentTypeSelectionProps {
  onSelectType: (type: string) => void;
}

export const DocumentTypeSelection: React.FC<DocumentTypeSelectionProps> = ({
  onSelectType,
}) => {
  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-2">
        <Title level={4}>Create Document</Title>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <Button
          className="p-4 flex flex-col items-center justify-center h-auto"
          onClick={() => onSelectType("INVENTORY")}
        >
          <FileText size={24} className="mb-2 text-blue-600" />
          <Text>Inventory</Text>
        </Button>
        <Button
          className="p-4 flex flex-col items-center justify-center h-auto"
          onClick={() => onSelectType("ADMINISTRATIVE")}
        >
          <FileText size={24} className="mb-2 text-green-600" />
          <Text>Administrative</Text>
        </Button>
        <Button
          className="p-4 flex flex-col items-center justify-center h-auto"
          onClick={() => onSelectType("LEGAL")}
        >
          <FileText size={24} className="mb-2 text-red-600" />
          <Text>Legal</Text>
        </Button>
        <Button
          className="p-4 flex flex-col items-center justify-center h-auto"
          onClick={() => onSelectType("SUPPLEMENTARY")}
        >
          <FileText size={24} className="mb-2 text-purple-600" />
          <Text>Supplementary</Text>
        </Button>
        <Button
          className="p-4 flex flex-col items-center justify-center h-auto"
          onClick={() => onSelectType("OTHER")}
        >
          <FileText size={24} className="mb-2 text-gray-600" />
          <Text>Other</Text>
        </Button>
      </div>
    </div>
  );
};